import React, {Component} from "react";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';

import 'leaflet/dist/leaflet.css'

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

//NOTE: YOU MUST HAVE A CONTAINER DIV WITH A SPECIFIED WIDTH AND HEIGHT TO MAKE USE OF THIS COMPONENT!
//Also note, this component gives a hooks error if you try to modernize it, which is why it is still a React component
const position = [51.505, -0.09]
class LocationMap extends Component {
    constructor(props) {
        super()
    }

    render() {
        if (!this.props.sites) return null;
        let markers = []
        let count = 0;
        let latitudeSum = 0;
        let longitudeSum = 0;
        let chosenPosition = position;
        this.props.sites && this.props.sites.forEach(s => {
            if (s && s.latitude && s.longitude) {
                if (s.site_id == 24) {
                    console.log("Setting chosen position")
                    chosenPosition = [parseFloat(s.latitude), parseFloat(s.longitude)]
                }
                let position = [parseFloat(s.latitude), parseFloat(s.longitude)]
                count++;
                latitudeSum += parseFloat(s.latitude)
                longitudeSum += parseFloat(s.longitude)

                markers.push(
                    <Marker key={s.site_id} position={position}>
                        <Popup key={s.site_id}>
                            {s.name}
                        </Popup>
                    </Marker>
                )
            }
        })

        let center = chosenPosition || count > 0 ? [latitudeSum / count, longitudeSum/count] : position

        return (
            <div className="locations-map-container">
                <MapContainer center={center} zoom={this.props.zoomOverride || 5} scrollWheelZoom={false}>
                    <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                    { markers}
            </MapContainer>
            </div>
        )
    }

    

}

export default LocationMap;
